export const getSiteTheme = () => {
  const siteTheme = localStorage.getItem('siteTheme');
  const isLight = siteTheme === 'light';

  return { siteTheme, isLight };
};
